import type { WeatherPayload } from '@jums-dashboard/shared';
import { useQuery } from '@tanstack/react-query';

import { callFunction } from '@/lib/callableClient';

import { DEFAULT_LOCATION, type WeatherLocation } from './config';
import { localDayKey, parseOpenMeteoResponse, type WeatherSnapshot } from './weatherDerive';

export type { DaySummary, HourSlot, SunEvent, WeatherCondition, WeatherSnapshot } from './weatherDerive';

async function fetchWeather(location: WeatherLocation): Promise<WeatherSnapshot> {
  const raw = await callFunction<WeatherPayload, unknown>('weatherForecast', {
    latitude: location.lat,
    longitude: location.lon,
    timezone: location.tz,
  });
  return parseOpenMeteoResponse(raw, new Date(), location);
}

export default function useWeather(location: WeatherLocation = DEFAULT_LOCATION) {
  const dayKey = localDayKey(Date.now(), location.tz);

  return useQuery({
    queryKey: ['weather', 'open-meteo', location.lat, location.lon, dayKey],
    queryFn: () => fetchWeather(location),
    staleTime: 15 * 60_000,
    refetchInterval: 15 * 60_000,
    gcTime: 60 * 60_000,
  });
}
